import React, { useCallback, useRef, useMemo } from "react";
import { connect } from "react-redux";
import FormField from '../../../../dynamicFormBuilder/FormField'
import { ConsigneeAdditionalLayout, EdiDefaultLayout } from "../../../common/Layouts";

function EdiDefaultTab(props) {
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    var currentUser = props.oidc.user;
    const formRefs = useRef({});
    const handleCodesFormLoad = useCallback(() => {
        props.additonalFormLookupsLoad(formRefs);
    }, []);


    const handleFieldChange = useCallback((name, value, e) => {
    }, []);



    return (
        <div className="FormMt">
            <FormField
                currrentUser={currentUser}
                layoutId='6FBD5311-882C-4F28-AE7D-828102B40336'
                layoutName='EdiDefaultTab'
                defaultFormSchema={ConsigneeAdditionalLayout}
                formFields={props.formFields}
                setformFields={props.setformFields}
                handleFieldValueChange={handleFieldChange}
                DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                formRefs={formRefs}
                onFormLoad={handleCodesFormLoad}
            />
        </div>

    );
}

function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}

export default connect(mapStateToProps)(EdiDefaultTab);
